<template>
  <v-data-table
    v-if="!isSala"
    :headers="visualizarPontosMedalha ? headers : headersSemPontos"
    :items="perguntasRejeitadas"
    class="elevation-1"
    hide-default-footer
    disable-pagination
    :expanded.sync="expanded"
    single-expand
    item-key="perguntaMunicipioId"
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
  >
    <template v-slot:item="props">
      <tr class="rejeitada">
        <td
          v-if="canDiscardQuestion(props.item)"
          @click="removeQuestion(props.item)"
          style="cursor: pointer"
          title="DESCARTAR QUESTÃO E EVIDÊNCIAS"
        >
          <img style="width: 30px" src="/assets/img/removeQuestion.png" />
        </td>
        <td v-else></td>
        <td>{{ props.item.nome }}</td>
        <td>{{ props.item.numero }}</td>
        <td @click="openEvidence(props.item)" v-if="props.item.temArquivo">
          <div class="optionsExpanded">
            <div style="width: 80%">
              <div>{{ props.item.texto }}</div>
              <div
                v-if="getRespostaNumericaInfo(props.item)"
                class="resposta-numerica-info"
              >
                {{ getRespostaNumericaInfo(props.item) }}
              </div>
            </div>
            <div
              :class="`openExpanded ${
                expanded.length > 0 &&
                props.item.perguntaMunicipioId ===
                  expanded[0].perguntaMunicipioId
                  ? 'expandedClass'
                  : ''
              }`"
              v-if="
                isFullAdmin ||
                (groupsConfig.visualizarRejeitadas &&
                  config.visualizarRejeitadas)
              "
            ></div>
          </div>
        </td>
        <td v-else></td>
        <td v-if="!isSala">{{ props.item.pontos }}</td>
        <td width="300px">
          <template
            v-if="
              isFullAdmin ||
              !isSala ||
              (isSala &&
                JSON.parse(config.visualizaEixosIds || '[]').includes(
                  props.item.eixoId
                ))
            "
          >
            <v-file-input
              v-if="groupsConfig.enviarRejeitadas && config.enviarRejeitadas"
              multiple
              label="Selecione Arquivos de Evidência"
              v-model="props.item.arquivos"
            >
            </v-file-input>
          </template>
        </td>
        <td>
          <template
            v-if="
              isFullAdmin ||
              !isSala ||
              (isSala &&
                JSON.parse(config.visualizaEixosIds || '[]').includes(
                  props.item.eixoId
                ))
            "
          >
            <v-btn
              v-if="groupsConfig.enviarRejeitadas && config.enviarRejeitadas"
              color="primary"
              class="ml-3"
              @click="sendEvidences(props.item)"
            >
              <span v-if="isSala">Carregar</span>
              <span v-else>Enviar</span>
            </v-btn>
          </template>
        </td>
        <td v-if="props.item.evidencia">
          <app-modal-show-evidence
            :evidence="props.item.evidencia"
            :color="'primary'"
            :isHtml="isSala ? true : false"
          >
          </app-modal-show-evidence>
        </td>
        <td v-else></td>
        <td v-if="props.item.temArquivo">
          <div class="hasEvidence"></div>
        </td>
        <td v-if="!props.item.temArquivo">
          <div class="hasNoEvidence"></div>
        </td>
      </tr>
    </template>
    <template v-slot:expanded-item="props">
      <tr
        v-if="
          isFullAdmin ||
          (groupsConfig.visualizarRejeitadas && config.visualizarRejeitadas)
        "
      >
        <td colspan="9" class="p-0">
          <app-get-evidence-question
            :perguntaId="props.item.perguntaMunicipioId"
            @updateValue="updateValue"
            :evidences="evidences"
            :type="'Rejeitadas'"
            :canAnalyze="canAnalyzeQuestion(props.item)"
          >
          </app-get-evidence-question>
        </td>
      </tr>
    </template>
    <template slot="no-data">
      <span> Nenhuma pergunta retornada </span>
    </template>
  </v-data-table>
  <rejeitada-selo
    :visualizarPontosMedalha="visualizarPontosMedalha"
    :headers="headers"
    :headersSemPontos="headersSemPontos"
    :perguntasRejeitadas="perguntasRejeitadas"
    :payload="payload"
    :rulesArquivo="rules"
    :expanded="expanded"
    @openEvidence="openEvidence"
    :evidences="evidences"
    @removeQuestion="removeQuestion"
    @updateValue="updateValue"
    @load="loadRejectedQuestions"
    @loadEvidence="loadEvidencesChildren"
    @sendEvidences="sendEvidences"
    @enviarAnalise="(e) => salvarDadosComplementares(e, true)"
    v-else
  ></rejeitada-selo>
</template>

<script>
import { cityQuestionAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import AppModalShowEvidence from "@/modules/diagnostic/components//ModalShowEvidence";
import AppGetEvidenceQuestion from "@/modules/evidence/components/GetQuestion";
import Swal from "sweetalert2";
import { sortArrayAsc } from "../../../../helpers/utils";
import RejeitadaSelo from "./selo/RejeitadaSelo.vue";
import moment from "moment";
import { isWorkday } from "@/helpers/workingDay";
import { getRespostaNumericaInfo as buildRespostaNumericaInfo } from "./utils";
import { confirmarAnaliseIaUpload } from "./preAnaliseUpload";
export default {
  components: {
    AppModalShowEvidence,
    AppGetEvidenceQuestion,
    RejeitadaSelo,
  },
  data() {
    return {
      headers: [
        { text: "", value: "removeEvidence" },
        { text: "Tema", value: "tema.nome" },
        { text: "Número", value: "numero" },
        { text: "Texto", value: "texto" },
        { text: "Pontos", value: "pontos" },
        { text: "", value: "enviar" },
        { text: "", value: "acao" },
        { text: "Evidência", value: "evidencia" },
        { text: "Arquivo", value: "evidenciado" },
      ],
      headersSemPontos: [
        { text: "", value: "removeEvidence" },
        { text: "Tema", value: "tema.nome" },
        { text: "Número", value: "numero" },
        { text: "Texto", value: "texto" },
        { text: "", value: "enviar" },
        { text: "", value: "acao" },
        { text: "Evidência", value: "evidencia" },
        { text: "Arquivo", value: "evidenciado" },
      ],
      municipioId: this.$route.params.id,
      perguntasRejeitadas: [],
      expanded: [],
      allPerguntas: [],
      evidences: [],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      user: JSON.parse(localStorage.getItem("user")),
      payload: {},
      sortBy: ["nome"],
      sortDesc: [false],
      rules: [
        (files) => {
          if (files && Array.isArray(files)) {
            var somaTotal = files.reduce((a, b) => {
              return a + b.size;
            }, 0);

            return somaTotal > 209715200
              ? "Total de arquivos não pode ser maior que 200MB!"
              : true;
          } else if (files && !Array.isArray(files)) {
            return files.size > 209715200
              ? "Arquivo não pode ser maior que 200MB!"
              : true;
          }

          return !files;
        },
      ],
    };
  },
  props: {
    filter: { type: Object, default: () => ({}) },
    visualizarPontosMedalha: false,
  },
  watch: {
    filter: {
      handler(val, oldVal) {
        if (val.temas.length)
          this.perguntasRejeitadas = this.allPerguntas.filter((pa) =>
            val.temas.some((te) => te.nome === pa.nome)
          );
        else this.perguntasRejeitadas = this.allPerguntas;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    getRespostaNumericaInfo(question) {
      return buildRespostaNumericaInfo(question);
    },
    canAnalyzeQuestion(question) {
      if (this.isFullAdmin) return true;
      if (
        !this.user ||
        !this.user.grupo ||
        this.user.grupo.nome !== "Avaliador Sebrae"
      ) {
        return true;
      }

      const questionMunicipioId = question.municipioId || question.MunicipioId;
      const questionEixoId =
        question.eixoId ||
        question.EixoId ||
        (question.tema && (question.tema.eixoId || question.tema.EixoId));

      return (this.user.permissoes || []).some((permission) => {
        const municipioPermitido =
          !permission.municipioId ||
          Number(permission.municipioId) === Number(questionMunicipioId);
        const eixoPermitido =
          !permission.eixoId ||
          Number(permission.eixoId) === Number(questionEixoId);

        return municipioPermitido && eixoPermitido;
      });
    },
    canDiscardQuestion(question) {
      return (
        this.isFullAdmin ||
        (this.config &&
          this.groupsConfig &&
          this.config.descartarEvidencias &&
          this.groupsConfig.descartarEvidencias &&
          this.canAnalyzeQuestion(question))
      );
    },
    untilDay() {
      let dayUtil = 2;
      let dayAtual = moment("28/05/2024", "DD/MM/YYYY");

      while (dayUtil > 0) {
        dayAtual = moment(dayAtual).add(1, "days");

        if (isWorkday(dayAtual)) {
          dayUtil--;
        }
      }
    },
    removeQuestion(pergunta) {
      if (!this.canDiscardQuestion(pergunta)) return;

      Swal.fire({
        title: "Atenção!",
        text: `Deseja realmente DESCARTAR esta questão e todas as suas evidências para retorno da mesma à
             situação de RESPONDIDAS? Desta forma, no próximo acompanhamento a questão aparecerá novamente e o
             ${
               this.isGov ? "projeto" : "município"
             }  perderá os pontos correspondentes`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((result) => {
        if (result.isConfirmed) {
          this.setLoading(true);

          cityQuestionAPI
            .atualizarPergunta(pergunta.perguntaMunicipioId)
            .then(() => {
              this.loadRejectedQuestions();
            })
            .catch(() => {
              this.setLoading(false);
              this.$notification.error("Erro ao salvar remover questão");
            });
        }
      });
    },
    openEvidence(evidenceSlot, deixarAberto) {
      if (this.expanded.length > 0) {
        this.expanded.forEach((item, index) => {
          if (item === evidenceSlot && !deixarAberto) {
            this.expanded.splice(index, 1);
          } else {
            this.expanded = [];
            this.expanded.push(evidenceSlot);
          }
        });
      } else {
        this.expanded.push(evidenceSlot);
      }

      if (this.expanded.length > 0) {
        this.loadEvidencesChildren();
      } else {
        this.setLoading(false);
      }
    },
    loadEvidencesChildren() {
      this.setLoading(true);
      cityQuestionAPI
        .getPergunta(this.expanded[0].perguntaMunicipioId)
        .then((resp) => {
          this.evidences = resp.data.evidencias;
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },
    check(arquivos) {
      if (arquivos) {
        const arquivosSelecionados = Array.isArray(arquivos)
          ? arquivos
          : [arquivos];
        var somaTotal = arquivosSelecionados.reduce((a, b) => {
          return a + (b.size || 0);
        }, 0);

        return somaTotal > 209715200 ? false : true;
      }

      return true;
    },
    renameFile(originalFile, newName) {
      return new File([originalFile], newName, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      });
    },
    async sendEvidences(question, analise) {
      if (!this.isSala) {
        const valid = this.check(question.arquivos);
        if (!valid) return;
      }
      const dadosComple = question.perguntaId == 3;

      if (this.isSala) {
        if (
          !question.arquivosDados &&
          !question.arquivos &&
          !analise &&
          dadosComple
        ) {
          this.salvarDadosComplementares(question, analise);
          return;
        }
      }
      if (!question.arquivos && !this.isSala) {
        this.$notification.error("Não há evidências a serem enviadas!");
      } else {
        this.setLoading(true);

        let formData = new FormData();

        if (Array.isArray(question.arquivos)) {
          if (question.arquivos && question.arquivos.length) {
            for (let i = 0; i < question.arquivos.length; i++) {
              formData.append("arquivos", question.arquivos[i]);
            }
          }
        } else if (question.arquivos) {
          formData.append("arquivos", question.arquivos);
        }

        if (question.arquivosDados) {
          question.arquivosDados = this.renameFile(
            question.arquivosDados,
            "DADOS_COMPLE_" + question.arquivosDados.name
          );

          formData.append("arquivos", question.arquivosDados);
        }

        formData.append("perguntaMunicipioId", question.perguntaMunicipioId);
        const prosseguir = await confirmarAnaliseIaUpload(
          formData,
          (value) => this.setLoading(value),
          this.config,
          this.groupsConfig
        );
        if (!prosseguir) return;

        cityQuestionAPI
          .salvarEvidencias(formData)
          .then((resp) => {
            this.$notification.success("Evidência salva com sucesso", {
              success: {
                background: "#483D8B",
                color: "#fff",
              },
            });
            if (this.isSala) {
              this.salvarDadosComplementares(question, analise);
            } else this.loadRejectedQuestions();
          })
          .catch((err) => {
            console.log("err: ", err);
            this.setLoading(false);
            this.$notification.error("Erro ao salvar evidência");
          });
      }
    },
    salvarDadosComplementares(pergunta, analise) {
      this.setLoading(true);

      delete pergunta.arquivos;
      delete pergunta.arquivosDados;
      delete pergunta.evidence;

      if (analise) {
        pergunta.evidenciada = true;
        pergunta.rejeitada = false;
      }
      pergunta.salvo = true;

      cityQuestionAPI
        .put(pergunta)
        .then((resp) => {
          this.loadRejectedQuestions(analise ? null : pergunta, analise);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao salvar Pergunta");
        });
    },
    loadRejectedQuestions(question, analise) {
      this.setLoading(true);
      cityQuestionAPI
        .getRejeitadas(this.municipioId)
        .then((resp) => {
          this.perguntasRejeitadas = resp.data.sort((a, b) => {
            return (
              sortArrayAsc(a.nome, b.nome) || sortArrayAsc(a.texto, b.texto)
            );
          });

          if (!this.user.grupo.verTodosEixos) {
            this.perguntasRejeitadas = this.perguntasRejeitadas.filter((item) =>
              this.user.permissoes.some(
                (per) =>
                  per.eixoId === item.eixoId &&
                  per.municipioId === item.municipioId
              )
            );
          }
          this.allPerguntas = this.perguntasRejeitadas;

          if (question) {
            this.openEvidence(question, true);
          } else {
            if (analise)
              this.$notification.success("Evidência enviada para análise");
            this.setLoading(false);
          }
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter perguntas");
        });
    },
    loadQuestion(perguntaMunicipioId, index) {
      cityQuestionAPI
        .getPergunta(perguntaMunicipioId)
        .then((resp) => {
          this.perguntasRejeitadas[index].evidencias = resp.data.evidencias;
          this.allPerguntas = this.perguntasRejeitadas;

          if (this.filter.temas.length > 0) {
            this.perguntasEvidenciadas = this.allPerguntas.filter((pa) =>
              this.filter.temas.some((te) => te.nome === pa.nome)
            );
          }

          this.$forceUpdate();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },
    updateValue(e) {
      this.loadRejectedQuestions();
    },
  },
  mounted() {
    this.loadRejectedQuestions();

    if (this.isSala) {
      this.headers = [
        { text: "Pilar", value: "nome" },
        { text: "Faixa", value: "faixanome" },
        { text: "Critério", value: "texto" },
        { text: "", value: "mostrarArquivos", sortable: false },
        { text: "", value: "enviar", sortable: false },
        { text: "", value: "acao", sortable: false },
        { text: "Evidência", value: "evidencia" },
        { text: "Arquivo", value: "temArquivo" },
      ];
      this.headersSemPontos = [
        { text: "Pilar", value: "nome" },
        { text: "Faixa", value: "faixanome" },
        { text: "Critério", value: "texto" },
        { text: "", value: "mostrarArquivos", sortable: false },
        { text: "", value: "enviar", sortable: false },
        { text: "", value: "acao", sortable: false },
        { text: "Evidência", value: "evidencia" },
        { text: "Arquivo", value: "temArquivo" },
      ];
    } else {
      this.headers = [
        { text: "", value: "removeEvidence", sortable: false },
        { text: "Tema", value: "nome" },
        { text: "Número", value: "numero" },
        { text: "Texto", value: "texto" },
        { text: "Pontos", value: "pontos" },
        { text: "", value: "enviar", sortable: false },
        { text: "", value: "acao", sortable: false },
        { text: "Evidência", value: "evidencia" },
        { text: "Arquivo", value: "temArquivo" },
      ];
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated", "isFullAdmin", "isSala", "isParceiro"]),
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
}
.p-0 {
  padding: 0 !important;
}
.resposta-numerica-info {
  color: #666;
  font-size: 11px;
  line-height: 1.3;
  margin-top: 4px;
}
.hasEvidence {
  background: url("/assets/img/certo1.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}
.hasNoEvidence {
  background: url("/assets/img/noEvidence.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}
.semStatus {
  background: url("/assets/img/search.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
}

.optionsExpanded {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.openExpanded {
  background: url("/assets/img/right-arrow.png") no-repeat;
  width: 20px;
  height: 20px;
  transform: rotate(90deg);
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
  float: right;
}
.expandedClass {
  transform: rotate(270deg);
}
</style>
